import type { TableColumnProps } from './VirtualTableThCell'
import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import './styles/virtual-table-td-column.scss'

type VirtualTableCellProps = {
  column: TableColumnProps
  data: Record<string, any>
}

export const VirtualTableCell = defineComponent<VirtualTableCellProps>({
  props: DefineComponentProps<VirtualTableCellProps>(['column', 'data']),
  setup(props) {
    return () => (
      <div
        style={{
          '--flex': props.column.width ? `0 0 ${props.column.width}` : 1,
        }}
        class={'virtual-table-td-column'}
      >
        <div class={classNames('cell', props.column.align || 'left')}>
          {props.column.render
            ? props.column.render({
                row: props.data,
                rowIndex: 0,
                cellIndex: 0,
              })
            : props.data[props.column.prop]}
        </div>
      </div>
    )
  },
})
